module.exports = __webpack_public_path__ + "assets/no-view.d8f9db41.svg";